import { OnboardingStatus } from '@Store/index';

/**
 * Terminal KYC/KYB failure statuses (backend `OnboardingStatus.isDeclined()`).
 * These customers have no way to continue onboarding and are always routed to the
 * KYC failed page. The login API may return their profile without an access token.
 */
const DECLINED_ONBOARDING_STATUSES: readonly OnboardingStatus[] = [
  OnboardingStatus.KYB_FAILED_FINAL,
  OnboardingStatus.KYC_FAILED_FINAL,
  OnboardingStatus.KYC_FAILED_PARTNER,
];

export const isDeclinedOnboardingStatus = (status?: OnboardingStatus) =>
  status !== undefined && DECLINED_ONBOARDING_STATUSES.includes(status);
